module.exports = __webpack_public_path__ + "img/product-program-yszc-icon3.43821cc5.png";